import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ArrowRight } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const BooksSection = () => {
  const [books, setBooks] = useState([]);

  useEffect(() => {
    const fetchBooks = async () => {
      try {
        const res = await axios.get(`${API}/books`);
        setBooks(res.data);
      } catch (err) {
        console.error('Failed to fetch books:', err);
      }
    };
    fetchBooks();
  }, []);

  if (books.length === 0) return null;

  return (
    <section id="books" className="section-padding" style={{
      background: 'linear-gradient(180deg, #0f0a1e 0%, #1a0e2e 100%)',
    }}>
      <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
        <h2 style={{
          textAlign: 'center',
          fontSize: 'clamp(32px, 4vw, 48px)',
          fontWeight: 700,

          marginBottom: '12px',
        }}>
          Sacred Texts & <span style={{ color: '#00d4ff' }}>Books</span>
        </h2>
        <p style={{
          textAlign: 'center',
          fontSize: '15px',
          color: '#b0adc0',
          marginBottom: '12px',
        }}>
          Ancient wisdom and modern quantum theory captured in profound literature.
        </p>
        <div className="section-divider" style={{ marginBottom: '50px' }} />

        <div className="grid-books">
          {books.map((book) => (
            <div
              key={book.book_id}
              className="glass-card"
              style={{
                overflow: 'hidden',
                transition: 'transform 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease',
              }}
              onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-6px)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; }}
            >
              <div style={{ height: '220px', overflow: 'hidden' }}>
                <img
                  src={book.image}
                  alt={book.title}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              </div>
              <div style={{ padding: '24px', textAlign: 'center' }}>
                <h3 style={{
                  fontSize: '20px',
                  fontWeight: 700,
                  color: '#ffffff',
                  marginBottom: '6px',
                  textAlign: 'center',
                }}>
                  {book.title}
                </h3>
                <p style={{
                  fontSize: '13px',
                  color: '#00d4ff',
                  fontWeight: 500,
                  marginBottom: '12px',
                  textAlign: 'center',
                }}>
                  {book.author}
                </p>
                <p style={{
                  fontSize: '14px',
                  color: '#b0adc0',
                  lineHeight: 1.6,
                  marginBottom: '16px',
                  textAlign: 'center',
                }}>
                  {book.description}
                </p>
                <div style={{ display: 'flex', gap: '8px', marginBottom: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
                  {book.tags.map((tag) => (
                    <span
                      key={tag}
                      style={{
                        background: 'rgba(139, 92, 246, 0.2)',
                        border: '1px solid rgba(139, 92, 246, 0.3)',
                        color: '#c4b5fd',
                        padding: '4px 12px',
                        borderRadius: '16px',
                        fontSize: '11px',
                        fontWeight: 500,
                      }}
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <button
                  onClick={() => { if (book.link) window.open(book.link, '_blank', 'noopener,noreferrer'); }}
                  data-testid={`book-read-more-${book.book_id}`}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: '#00d4ff',
                    fontSize: '14px',
                    fontWeight: 500,
                    cursor: book.link ? 'pointer' : 'default',
                    opacity: book.link ? 1 : 0.5,
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '6px',
                    fontFamily: 'Inter, sans-serif',
                    padding: 0,
                    margin: '0 auto',
                  }}
                  onMouseEnter={(e) => { if (book.link) e.currentTarget.style.gap = '10px'; }}
                  onMouseLeave={(e) => { if (book.link) e.currentTarget.style.gap = '6px'; }}
                >
                  Go to Bookstore <ArrowRight size={16} />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BooksSection;
